import { createContext } from "react";

const agentNavigationContext = createContext();

export default agentNavigationContext;
